import React, { useState } from 'react';
import { X } from 'lucide-react';
export function LegalFooter() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-white border-t border-gray-100 py-4 text-center" data-id="element-45">
        <div className="flex justify-center gap-6 text-sm text-[#6B5D4F]" data-id="element-46">
          <button onClick={() => setActiveModal('privacy')} className="hover:text-[#2D1F0E] transition-colors underline underline-offset-4 min-h-[44px] px-2" data-id="element-47">
            Política de Privacidad
          </button>
          <button onClick={() => setActiveModal('terms')} className="hover:text-[#2D1F0E] transition-colors underline underline-offset-4 min-h-[44px] px-2" data-id="element-48">
            Términos de Uso
          </button>
        </div>
        <p className="text-xs text-gray-400 mt-4" data-id="element-49">
          © {new Date().getFullYear()} Protocolo SOS. Todos los derechos
          reservados.
        </p>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-50">
          <div className="bg-white rounded-2xl w-full max-w-lg max-h-[85vh] flex flex-col shadow-2xl" data-id="element-51">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-5 border-b border-gray-100" data-id="element-52">
              <h3 className="text-lg font-bold text-[#2D1F0E] font-serif" data-id="element-53">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos de Uso'}
              </h3>
              <button onClick={closeModal} className="p-2 text-gray-400 hover:text-gray-800 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-54">
                <X className="w-5 h-5" data-id="element-55" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-5 overflow-y-auto text-sm text-[#6B5D4F] space-y-4" data-id="element-56">
              {activeModal === 'privacy' ? <>
                  <section data-id="element-57">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-58">
                      Información que Recopilamos
                    </h4>
                    <p data-id="element-59">
                      Recopilamos información básica necesaria para procesar su
                      compra y entregar el producto digital, como nombre y
                      dirección de correo electrónico.
                    </p>
                  </section>
                  <section data-id="element-60">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-61">
                      Cómo Usamos la Información
                    </h4>
                    <p data-id="element-62">
                      Utilizamos su información exclusivamente para enviarle el
                      acceso al producto adquirido, enviar recibos y
                      comunicarnos sobre actualizaciones relevantes del
                      producto.
                    </p>
                  </section>
                  <section data-id="element-63">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-64">
                      Acceso al Producto Digital
                    </h4>
                    <p data-id="element-65">
                      El acceso se otorga mediante un enlace seguro enviado al
                      correo electrónico proporcionado durante la compra.
                    </p>
                  </section>
                  <section data-id="element-66">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-67">
                      Procesamiento de Pagos
                    </h4>
                    <p data-id="element-68">
                      Los pagos son procesados a través de pasarelas de pago
                      seguras de terceros. No almacenamos información completa
                      de tarjetas de crédito en nuestros servidores.
                    </p>
                  </section>
                  <section data-id="element-69">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-70">
                      Cookies y Analíticas
                    </h4>
                    <p data-id="element-71">
                      Utilizamos cookies esenciales para el funcionamiento del
                      sitio y analíticas básicas para entender cómo los usuarios
                      interactúan con nuestra página, con el fin de mejorar la
                      experiencia.
                    </p>
                  </section>
                  <section data-id="element-72">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-73">
                      Protección de Datos
                    </h4>
                    <p data-id="element-74">
                      Implementamos medidas de seguridad estándar de la
                      industria para proteger su información personal contra
                      acceso no autorizado o divulgación.
                    </p>
                  </section>
                  <section data-id="element-75">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-76">
                      Actualizaciones de la Política
                    </h4>
                    <p data-id="element-77">
                      Nos reservamos el derecho de actualizar esta política en
                      cualquier momento. Los cambios entrarán en vigor
                      inmediatamente después de su publicación en esta página.
                    </p>
                  </section>
                </> : <>
                  <section data-id="element-78">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-79">
                      Compra de Producto Digital
                    </h4>
                    <p data-id="element-80">
                      Al realizar la compra, usted adquiere una licencia para
                      acceder y descargar el material digital "Protocolo SOS".
                    </p>
                  </section>
                  <section data-id="element-81">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-82">
                      Uso Personal Exclusivo
                    </h4>
                    <p data-id="element-83">
                      El material proporcionado es estrictamente para uso
                      personal y familiar. No está autorizado para uso
                      comercial, clínico o institucional.
                    </p>
                  </section>
                  <section data-id="element-84">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-85">
                      Prohibición de Redistribución
                    </h4>
                    <p data-id="element-86">
                      Queda estrictamente prohibida la copia, reproducción,
                      reventa, distribución o publicación del material, ya sea
                      de forma gratuita o comercial.
                    </p>
                  </section>
                  <section data-id="element-87">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-88">
                      Sin Garantías Médicas
                    </h4>
                    <p data-id="element-89">
                      Este producto no ofrece garantías de resultados
                      específicos. No constituye asesoramiento médico,
                      psicológico ni psiquiátrico.
                    </p>
                  </section>
                  <section data-id="element-90">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-91">
                      Propósito Educativo
                    </h4>
                    <p data-id="element-92">
                      El contenido es puramente informativo y educativo. Es una
                      herramienta de apoyo para padres y no sustituye el
                      diagnóstico o tratamiento profesional.
                    </p>
                  </section>
                  <section data-id="element-93">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-94">
                      Política de Reembolso
                    </h4>
                    <p data-id="element-95">
                      Debido a la naturaleza digital e inmediata del producto,
                      las ventas son finales. Evaluaremos solicitudes
                      excepcionales caso por caso a nuestra entera discreción.
                    </p>
                  </section>
                  <section data-id="element-96">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-97">
                      Derecho de Actualización
                    </h4>
                    <p data-id="element-98">
                      Nos reservamos el derecho de modificar, actualizar o
                      retirar contenido del producto digital en cualquier
                      momento sin previo aviso.
                    </p>
                  </section>
                  <section data-id="element-99">
                    <h4 className="font-bold text-[#2D1F0E] mb-1" data-id="element-100">
                      Aceptación de Términos
                    </h4>
                    <p data-id="element-101">
                      Al completar la compra o utilizar el producto, usted
                      acepta expresamente estos términos de uso en su totalidad.
                    </p>
                  </section>
                </>}
            </div>

            {/* Modal Footer */}
            <div className="p-4 border-t border-gray-100 text-center" data-id="element-102">
              <button onClick={closeModal} className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-6 rounded-full transition-colors min-h-[44px]" data-id="element-103">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}